const TransactionType = {
  Deposit: 1,
  Withdrawal: 2,
};

export const TransactionTypeNames = {
  [TransactionType.Deposit]: "Deposit",
  [TransactionType.Withdrawal]: "Withdrawal",
};
